import { type PromosV2 } from '@hungryroot/rest';
import { type PromosV1 } from '@hungryroot/rest/api/get_pricing_config/get';
import { getLabelAndValue } from './getLabelAndValue';

export const getPromos = (
  promos?: PromosV1[] | PromosV2[],
  discount?: number
) => {
  return promos?.map(
    ({
      effect,
      is_expired: isExpired,
      code,
      type,
      threshold,
    }: PromosV1 | PromosV2) => {
      return {
        isExpired,
        code,
        type,
        threshold: Number(threshold),
        ...getLabelAndValue({ type, effect, discount: Number(discount) }),
      };
    },
    []
  );
};
